import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { Auth, Seo } from 'ui-components'
import { isAuthenticated } from 'user-auth'
import { Form } from './Form'

export function SignIn() {
  const router = useRouter()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const checkAuth = async () => {
      const authenticated = await isAuthenticated()
      if (authenticated) {
        router.replace('/sign-in/callback')
      } else {
        setLoading(false)
      }
    }

    checkAuth()
  }, [router])

  if (loading) return null // or a spinner
  return (
    <>
      <Seo title='Sign In' />
      <Auth slots={{ Form }} />
    </>
  )
}
